<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       data-url="admin/contract/work_order/"
                       :extra-params="{'contract_id': contractId}"
                       :extra-filters="{'contract.id': [contractId]}"
                       data-key="work_orders"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-model="selectedItemIds"
                       v-bind="$attrs"
                       class="contract-work-order-list">
    <template #item.nature="{item}">
      {{item.is_estimate ? 'Estimation': item.nature}}
    </template>
    <template v-slot:item.actions="{item}">
      <div class="d-flex">
<!--        <v-btn text-->
<!--               color="primary"-->
<!--               @click="$downloadFile(item.percentage_excel.id)">-->
<!--          Download-->
<!--        </v-btn>-->
        <v-btn text
               color="primary"
               @click="editItem(item)">
          EDIT
        </v-btn>
        <v-btn text
               color="primary"
               :to="{name: 'work-order-detail', params: {workOrderId: item.id}}">
          DIMBOOK
        </v-btn>
        <v-btn text
               color="primary"
               v-if="!item.finalised_at"
               @click="deleteItem(item)">
          DELETE
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import {ACTION_TYPES} from "@/store/types";
import EditWorkOrderDialog from "@/components/contract/EditWorkOrderDialog";

export default {
  name: 'ContractWorkOrderList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    refreshTrigger: Boolean,

    contractId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh(true);
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([])

    // Data Table
    const headers = ref([
      {text: root.$t('work_order.contract_year'), value: 'contract_year.year', width: 100},
      {text: root.$t('work_order.work_order_no'), value: 'work_order_no', width: 150},
      {text: root.$t('work_order.name'), value: 'name'},
      {text: root.$t('work_order.admin'), value: 'admin.username'},
      {text: root.$t('work_order.nature'), value: 'nature', width: 150, sortable: true},
      {text: '', value: 'actions', sortable: false, width: 250},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });
    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = async function (item) {
      const needRefresh = await root.$dialog.showAndWait(EditWorkOrderDialog, {
        workOrder: item,
        contractId: root.$route.params.contractId,
        showClose: false,
        persistent: true,
      });

      if (needRefresh) {
        refresh();
      }
    }
    const exportPdf = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/export_pdf/',
        params: {
          section_id: item.id,
        },
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.pdf`;
      link.click();
    }
    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({text: root.$t('work_order.delete_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/work_order/delete/',
          params: {work_order_id: item.id},
        })

        if (response.body.success) {
          await refresh();
        }
      }
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      exportPdf,
      deleteItem,
    }
  }
}
</script>

<style lang="less">
</style>
